import _ from 'lodash'
import Vue from 'vue'

const set = require('set-value')

export const processDiscussions = (state, data) => {
  state.discussions = data
}

export const processComments = (state, data) => {
  let comments = []
  if (state.localDiscussions[data.discussion.id]) {
    comments = state.localDiscussions[data.discussion.id].comments.concat(data.comments)
  } else {
    comments = data.comments
  }
  set(state.localDiscussions, data.discussion.id + '.comments', comments)
  set(state.localDiscussions, data.discussion.id + '.id', data.discussion.id)
  set(state.localDiscussions, data.discussion.id + '.label', data.discussion.label)
}

export const processScollPosition = (state, data) => {
  if (state.localDiscussions[data.id]) {
    set(state.localDiscussions, data.id + '.position', data.position)
  }
}

export const processComment = (state, data) => {
  set(state.localDiscussions, data.id + '.comment', data.comment)
}

export const destroyComment = (state, data) => {
  set(state.localDiscussions, data.discussion + '.comments', _.filter(state.localDiscussions[data.discussion].comments, (o) => {
    return o.id !== data.id
  }))
}

export const clearDiscussion = (state, data) => {
  if (state.localDiscussions[data]) {
    Vue.delete(state.localDiscussions, data)
  }
}
